exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-form .el-input[data-v-79fd933c],.el-select[data-v-79fd933c]{width:180px}\n", ""]);

// exports
